import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props: any) => {
    const { pathname } = useLocation()

    useEffect(() => {
        requestAnimationFrame(() => {
            const body = document.querySelector('body');
            if (body) {
                body.scrollTo(0, 0);
            } else {
                window.scrollTo(0, 0);
            }
        });
    }, [pathname]);

    return <>{props.children}</>
};

export default ScrollToTop